import { useEffect, useRef, useCallback } from 'react';

const SITE_KEY = '0x4AAAAAADP41BhqrW98uZX2';

export default function Turnstile({ onToken }) {
  const containerRef = useRef(null);
  const widgetId = useRef(null);

  const renderWidget = useCallback(() => {
    if (!window.turnstile || !containerRef.current) return;
    // Don't render twice
    if (widgetId.current !== null) return;
    widgetId.current = window.turnstile.render(containerRef.current, {
      sitekey: SITE_KEY,
      callback: (token) => onToken?.(token),
      'expired-callback': () => onToken?.(''),
      'error-callback': () => onToken?.(''),
      theme: 'light',
      size: 'flexible',
    });
  }, [onToken]);

  useEffect(() => {
    // If turnstile script already loaded
    if (window.turnstile) {
      renderWidget();
      return;
    }
    // Load script
    const existing = document.querySelector('script[src*="turnstile"]');
    if (!existing) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => renderWidget();
      document.head.appendChild(script);
    } else {
      existing.addEventListener('load', renderWidget);
    }

    return () => {
      if (widgetId.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetId.current); } catch {}
        widgetId.current = null;
      }
    };
  }, [renderWidget]);

  // Reserve the widget's height so the form doesn't shift when it loads.
  return <div ref={containerRef} className="mt-1" style={{ minHeight: 65 }} />;
}
